import React from 'react'
import { Link } from 'react-router-dom'
import '../../Styles/NotFound.css'

const NotFound = () => {
    return (
        <div>
            <main class="container">
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">4</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <span class="particle">0</span>
                <article class="content">
                    <p>Damnit stranger,</p>
                    <p>
                        You got lost in the <strong>404</strong> galaxy.
                    </p>
                    <p>
                        <Link to="/">
                            <button>Go back to earth.</button>
                        </Link>
                    </p>
                </article>
            </main>
        </div>
    )
}

export default NotFound
